import { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/providers/AuthProvider';

export function LoginPage() {
  const { signIn, status, error } = useAuth();
  const [submitting, setSubmitting] = useState(false);

  const onSignIn = async () => {
    setSubmitting(true);
    try {
      await signIn();
    } catch (e) {
      // Real errors surface via the AuthProvider's error state.
      // Popup-cancelled / blocked are silently dropped.
      console.warn('signIn failed', e);
    } finally {
      setSubmitting(false);
    }
  };

  const isLoading = status === 'loading' || submitting;
  const isForbidden = status === 'forbidden';

  return (
    <div className="bg-background flex min-h-screen items-center justify-center p-6">
      <Card className="w-full max-w-sm">
        <CardHeader className="items-center text-center">
          <div className="bg-primary text-primary-foreground mx-auto mb-2 flex size-10 items-center justify-center rounded-lg text-base font-bold">
            S
          </div>
          <CardTitle className="text-xl">Servo Admin</CardTitle>
          <CardDescription>
            Sign in with your <strong>@musicdatalabs.com</strong> Google account.
          </CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col gap-3">
          <Button onClick={() => void onSignIn()} disabled={isLoading} className="w-full">
            <GoogleIcon className="size-4" />
            {isLoading ? 'Signing in…' : 'Sign in with Google'}
          </Button>
          {isForbidden && error && (
            <p className="text-destructive text-center text-xs">{error}</p>
          )}
        </CardContent>
      </Card>
    </div>
  );
}

function GoogleIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden>
      <path
        fill="#EA4335"
        d="M12 10.2v3.9h5.5c-.2 1.4-1.6 4.1-5.5 4.1-3.3 0-6-2.7-6-6.1s2.7-6.1 6-6.1c1.9 0 3.1.8 3.8 1.5l2.6-2.5C16.7 3.5 14.6 2.5 12 2.5 6.7 2.5 2.5 6.7 2.5 12s4.2 9.5 9.5 9.5c5.5 0 9.1-3.9 9.1-9.3 0-.6-.1-1.1-.2-1.5z"
      />
    </svg>
  );
}
